module.exports = __webpack_public_path__ + "static/media/hotel-14.1c163ceb.jpg";